import { CardOneComponentConfig } from '..';

export interface CardOneListCardClickOutput {
    data?: any;
    item: CardOneComponentConfig;
}
